/**
 * AirbnbSection — Airbnb (default-channel) Owner Payout label and tooltip copy for BookingDetailModal
 *
 * Charter: documentation/cursor/Charters/CodeAuditor.md v1.0.1
 * Phase 3e extracted from BookingDetailModal.jsx; JSX and strings unchanged.
 *
 * Purpose:
 *   Render Airbnb folio label content ("Paid to Owner" with optional payoutLabel
 *   parenthetical) and provide tooltip copy for the Airbnb/default payout info icon.
 *   Presentational only; parent passes theme, hostPayout; parent owns predicate flags and tooltip show/hide.
 *
 * Assumptions & Invariants:
 *   - Presentational; no fetch; no admin imports.
 *   - getAirbnbPayoutTooltipText is pure: same inputs → same string. Call when isAirbnb (or default/else) for Owner Payout tooltip.
 *
 * Dependencies: React only
 *
 * Version: 1.0.0
 *
 * Changelog:
 *   2026-01-27 Phase 3e extraction from BookingDetailModal (Airbnb label + tooltip helper).
 */

const labelSubtextStyle = {
  fontSize: '12px',
  fontStyle: 'italic',
  opacity: 0.8,
  marginLeft: '4px',
};

/**
 * Returns Airbnb/default tooltip string for Owner Payout info icon.
 * Final: "Final payout amount confirmed after stay completion."
 * Provisional: "Estimated by channel. Payout typically arrives ~5-7 business days after check-in (Airbnb). Timing is controlled by Airbnb."
 * @param {boolean} isFinalCopy
 * @param {boolean} _isAirbnb — reserved for API parity; not used (strings are for Airbnb/default case).
 * @returns {string}
 */
export function getAirbnbPayoutTooltipText(isFinalCopy, _isAirbnb) {
  if (isFinalCopy) {
    return 'Final payout amount confirmed after stay completion.';
  }
  return 'Estimated by channel. Payout typically arrives ~5-7 business days after check-in (Airbnb). Timing is controlled by Airbnb.';
}

/**
 * Renders Airbnb/default Owner Payout label content ("Paid to Owner" + optional payoutLabel).
 * @param {{ theme?: string, hostPayout?: { payoutLabel?: string } }}
 */
export default function AirbnbSection({ theme, hostPayout }) {
  if (hostPayout?.payoutLabel) {
    return (
      <>
        Paid to Owner
        <span style={labelSubtextStyle}>
          ({hostPayout.payoutLabel})
        </span>
      </>
    );
  }
  return 'Paid to Owner';
}
